<template>
  <v-form v-model="valid" @submit.prevent>
    <v-row
      dense
      class="mx-0"
      :class="[direction === 'row' ? 'flex-row' : 'flex-column']"
    >
      <v-col>
        <v-card
          outlined
          class="px-2 pt-1 d-flex flex-column justify-space-between"
        >
          <p class="mb-0 font-weight-medium">Taxa da Plataforma</p>
          <div class="d-flex align-end">
            <v-text-field
              v-model="fee.innerFee.fixed"
              dense
              :placeholder="`${parentFee?.innerFee?.fixed || '0,00'}`"
              :class="
                fee?.innerFee?.fixed && fee.innerFee.fixed > 0
                  ? 'input-bold'
                  : ''
              "
              class="mt-0"
              type="number"
              prefix="R$"
              hide-details
              min="0"
              style="width: 120px"
              :rules="[(v) => v >= 0]"
              height="40"
              :filled="!!fee?.innerFee?.fixed && fee.innerFee.fixed > 0"
            ></v-text-field>

            <v-text-field
              v-model="fee.innerFee.percent"
              dense
              type="number"
              :placeholder="`${parentFee?.innerFee?.percent || '0'}`"
              class="input-text-end mt-0"
              :class="
                !!fee?.innerFee?.percent && fee.innerFee.percent > 0
                  ? 'input-bold'
                  : ''
              "
              min="0"
              max="50"
              suffix="%"
              hide-details
              :filled="!!fee?.innerFee?.percent && fee.innerFee.percent > 0"
              height="40"
              style="width: 100px"
              :rules="[(v) => v >= 0 && v <= 50]"
            ></v-text-field>
          </div>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          outlined
          class="px-2 pt-1 d-flex flex-column justify-space-between"
        >
          <p class="mb-0 font-weight-medium">Taxa do Cliente</p>
          <div class="d-flex align-end">
            <v-text-field
              v-model="fee.outerFee.fixed"
              dense
              :placeholder="`${parentFee?.outerFee?.fixed || '0,00'}`"
              :class="
                !!fee?.outerFee?.fixed && fee.outerFee.fixed > 0
                  ? 'input-bold'
                  : ''
              "
              class="mt-0"
              type="number"
              prefix="R$"
              hide-details
              :filled="!!fee?.outerFee?.fixed && fee.outerFee.fixed > 0"
              height="40"
              min="0"
              :rules="[(v) => v >= 0]"
              style="width: 100px"
            ></v-text-field>

            <v-text-field
              v-model="fee.outerFee.percent"
              dense
              type="number"
              :placeholder="`${parentFee?.outerFee?.percent || '0'}`"
              min="0"
              class="input-text-end mt-0"
              :class="
                fee?.outerFee?.percent && fee.outerFee.percent > 0
                  ? 'input-bold'
                  : ''
              "
              max="50"
              suffix="%"
              :rules="[(v) => v >= 0 && v <= 50]"
              hide-details
              :filled="!!fee?.outerFee?.percent && fee.outerFee.percent > 0"
              height="40"
              style="width: 80px"
            ></v-text-field>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
const defaultFee = () => ({
  innerFee: { fixed: null, percent: null },
  outerFee: { fixed: null, percent: null },
});

export default {
  props: {
    direction: {
      type: String,
      default: "row",
    },
    gap: {
      type: String,
      default: "3",
    },
    value: {
      type: Array,
      default: () => [],
    },
    organizationId: {
      type: String,
      default: null,
    },
    partyId: {
      type: String,
      default: null,
    },
    ticketGroupId: {
      type: String,
      default: null,
    },
    ticketBlockId: {
      type: String,
      default: null,
    },
    paymentMethod: {
      type: String,
    },
    paymentType: {
      type: String,
      default: "UNKNOWN",
    },
  },
  data: () => ({
    valid: false,
    fee: defaultFee(),
  }),

  methods: {
    getFee() {
      const fee = this.value.find(
        (fee) =>
          fee.paymentMethod === this.paymentMethod &&
          fee.paymentType === this.paymentType &&
          fee.organizationId === this.organizationId &&
          fee.partyId === this.partyId &&
          fee.ticketGroupId === this.ticketGroupId &&
          fee.ticketBlockId === this.ticketBlockId
      );
      return fee;
    },
    updateFee() {
      this.fee = Object.assign(defaultFee(), this.getFee());
    },
    save() {
      if (!this.valid) return;
      const fee = this.fee;

      if (
        (fee.innerFee.fixed === "" || fee.innerFee.fixed === null) &&
        (fee.innerFee.percent === "" || fee.innerFee.percent === null) &&
        (fee.outerFee.fixed === "" || fee.outerFee.fixed === null) &&
        (fee.outerFee.percent === "" || fee.outerFee.percent === null)
      ) {
        const data = {
          paymentMethod: this.paymentMethod,
          paymentType: this.paymentType,
          organizationId: this.organizationId,
          partyId: this.partyId,
          ticketGroupId: this.ticketGroupId,
          ticketBlockId: this.ticketBlockId,
          innerFee: { fixed: null, percent: null },
          outerFee: { fixed: null, percent: null },
        };
        this.$emit("input", data);
        return data;
      }

      const data = {
        paymentMethod: this.paymentMethod,
        paymentType: this.paymentType,
        organizationId: this.organizationId,
        partyId: this.partyId,
        ticketGroupId: this.ticketGroupId,
        ticketBlockId: this.ticketBlockId,
        innerFee: {
          fixed: parseFloat(fee.innerFee.fixed || 0),
          percent: parseFloat(fee.innerFee.percent || 0),
        },
        outerFee: {
          fixed: parseFloat(fee.outerFee.fixed || 0),
          percent: parseFloat(fee.outerFee.percent || 0),
        },
      };
      this.$emit("input", data);
      return;
    },
  },
  computed: {
    scope() {
      if (!this.organizationId) return 0;
      if (!this.partyId) return 1;
      if (!this.ticketGroupId) return 2;
      if (!this.ticketBlockId) return 3;
      return 4;
    },
    parentFee() {
      return this.value.reduce((acc, fee) => {
        if (fee.paymentMethod !== this.paymentMethod) return acc;
        if (fee.paymentType !== this.paymentType) return acc;

        // Remove invalid fees
        if (fee.innerFee.fixed === null || fee.innerFee.percent === null)
          return acc;
        if (fee.outerFee.fixed === null || fee.outerFee.percent === null)
          return acc;

        // Remove fees with different scope
        if (
          fee.organizationId !== null &&
          fee.organizationId !== this.organizationId
        )
          return acc;
        if (fee.partyId !== null && fee.partyId !== this.partyId) return acc;
        if (
          fee.ticketGroupId !== null &&
          fee.ticketGroupId !== this.ticketGroupId
        )
          return acc;
        if (
          fee.ticketBlockId !== null &&
          fee.ticketBlockId !== this.ticketBlockId
        )
          return acc;

        // Get the most specific fee in the hierarchy
        if (!acc) return fee;
        if (!fee.organizationId) return fee;

        // Get the most specific fee in the hierarchy
        if (fee.ticketBlockId !== null && acc.ticketBlockId === null)
          return fee;
        if (fee.ticketGroupId !== null && acc.ticketGroupId === null)
          return fee;
        if (fee.partyId !== null && acc.partyId === null) return fee;
        if (fee.organizationId !== null && acc.organizationId === null)
          return fee;

        return acc;
      }, null);
    },
  },
  watch: {
    value: {
      handler(newVal) {
        // this.updateFee(newVal);
      },
      deep: true,
    },
    fee: {
      handler(newVal) {
        this.save();
      },
      deep: true,
    },
    organizationId: function (newVal) {
      this.updateFee(newVal);
    },
    partyId: function (newVal) {
      this.updateFee(newVal);
    },
    ticketGroupId: function (newVal) {
      this.updateFee(newVal);
    },
  },
  mounted() {
    this.updateFee();
    this.$root.$on("update:fees", (fees) => {
      this.updateFee();
    });
  },
};
</script>

<style lang="scss">
.input-text-end {
  input {
    text-align: end;
  }
}

.input-bold {
  input {
    font-weight: bold;
  }
}
</style>
